<template>
  <div>
    <b-row>
      <b-col>
        <span
          @click="active = !active"
          class="sample"
          :style="background"
        ></span>
      </b-col>
    </b-row>
    <b-row v-if="active">
      <b-col>
        <twitter v-model="color" @input="colorChanged" />
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { Twitter } from 'vue-color';

export default {
  name: 'ColorHandler',
  components: { Twitter },
  props: {
    value: String,
  },
  data() {
    return {
      color: { hex: '#fff' },
      active: false,
    };
  },
  mounted() {
    this.color.hex = this.value;
  },
  watch: {
    value(newValue) {
      this.color.hex = newValue;
    }
  },
  computed: {
    background() {
      return {
        background: this.color.hex + ' none repeat scroll 0% 0%',
      };
    },
  },
  methods: {
    colorChanged() {
      this.active = false;
      this.$emit('input', this.color.hex);
    },
  },
};
</script>

<style scoped>
.sample {
  width: 30px;
  height: 30px;
  float: left;
  border-radius: 4px;
  margin: 0 6px 6px 0;
  cursor: pointer;
  position: relative;
  outline: none;
  box-shadow: transparent 0px 0px 4px;
}
</style>